import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { ChevronIcon } from "../chevronIcon";
import { Props } from "./types";
import { getDecade, chunkByDecade } from "./utils";
import styles from "./styles.scss";

function Years({ cursor, editCursor, date, switchViews, ...props }: Props) {
  const { t } = useTranslation();
  const year = cursor.getFullYear();
  const decade = getDecade(year);
  const minDate = props.minDate
    ? new Date(props.minDate.year, props.minDate.month, props.minDate.day)
    : new Date(0);
  const maxDate = props.maxDate
    ? new Date(props.maxDate.year, props.maxDate.month, props.maxDate.day)
    : new Date(99999, 1);

  return (
    <div className={styles.calendar}>
      <div className={styles.heading}>
        <div
          className={classNames(styles.iconBox, {
            [styles.disabledIconBox]: new Date(year) <= minDate,
          })}
          onClick={(e) => {
            e.stopPropagation();
            editCursor({ year: year - 5 });
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.leftIcon)} />
        </div>
        <h3 className={styles.title}>
          {decade.min} - {decade.max}
        </h3>
        <div
          className={classNames(styles.iconBox, {
            [styles.disabledIconBox]: new Date(year) > maxDate,
          })}
          onClick={(e) => {
            e.stopPropagation();
            editCursor({ year: year + 5 });
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.rightIcon)} />
        </div>
      </div>
      <ul className={styles.main}>
        {chunkByDecade(decade).map((years, chunkIndex) => (
          <li key={chunkIndex} className={styles.years}>
            <ul className={styles.row}>
              {years.map((year) => (
                <li
                  key={year}
                  className={classNames(styles.year, {
                    [styles.selected]: year === date.year,
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    editCursor({ year, day: 10 });
                    switchViews("months");
                  }}
                >
                  <p className={styles.name}>{year}</p>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
      {!!props.today && (
        <div className={styles.clear} onClick={props.today}>
          <div className={styles.button}>
            <p>{t("calendar.today")}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export { Years };
